import { nextTick } from 'vue'

export function asyncNextTick() {
	return new Promise((resolve) => nextTick(resolve))
}

export function debounce(fn, delay = 128) {
	let timerId

	return function debounced(...args) {
		clearTimeout(timerId)
		timerId = setTimeout(() => fn.apply(this, args), delay)
	}
}
